import React from 'react';
import Head from "next/head";
import styled from "styled-components";

const ServerError = () => {
    return (
        <React.Fragment>
            <Head>
                <title>خطای 500</title>
                <meta name="robots" content="NOODP, nofollow, noindex"/>
            </Head>

            <Container className="text-center d-flex flex-column align-items-center justify-content-center">
                <img className="mb-40 mb-lg-56" width="560" src="/_img/errors/500.png"/>

                <p class="h2 px-24">
                    <span class="text-secondary">خطای 500</span>
                    <span> - درخواست شما با خطا مواجه شد!</span>
                </p>

                <p className="h4-normal">این مشکل به بخش پشتیبانی گزارش شده و سریعا رفع میشه.</p>

                <a href="/" className="btn btn-secondary mt-16">
                    صفحه اول 2نبش
                </a>
            </Container>
        </React.Fragment>
    );
};

export default ServerError;

// styles

const Container = styled.div`
	height: 100vh;

	@media (max-width: ${props => props.theme.screenXsMax}) {
		padding: 0 8px;
		img {
			width: 300px;
		}
	 }
`;
